import deepmerge from "deepmerge";
import { env } from "../env/env";

type Config = {
  coreBackendUrl: string;
  ssoFrontendUrl: string;
  helpCenterUrl: string;
  assetsUrl: string;
  datadogToken: string;
  sentryDsn: string;
  heapId: string;
};

const defaults: Config = {
  coreBackendUrl:
    env.NX_PUBLIC_CORE_BACKEND_URL ||
    "https://api-staging.studio.massivemusic.dev",
  ssoFrontendUrl:
    env.NX_PUBLIC_SSO_FRONTEND_URL || "https://staging.auth.songtradr.dev",
  helpCenterUrl: "https://studiohelp.massivemusic.com",
  assetsUrl:
    env.NX_PUBLIC_ASSETS_URL ||
    "https://assets-staging.studio.massivemusic.dev",
  datadogToken: "pubc8c7b3b6c5f81587a5d929683b6d16a2",
  sentryDsn:
    "https://575ab5f2470c86f1e102d043f6a31ea8@o363271.ingest.us.sentry.io/4510818495299584",
  heapId: "259303604",
};

const development = deepmerge<Config>(defaults, {
  coreBackendUrl: env.NX_PUBLIC_CORE_BACKEND_URL || "http://localhost:3333",
});

const preview = deepmerge<Config>(defaults, {});

const staging = deepmerge<Config>(defaults, {});

const production = deepmerge<Config>(defaults, {
  coreBackendUrl:
    env.NX_PUBLIC_CORE_BACKEND_URL || "https://api.studio.massivemusic.com",
  ssoFrontendUrl:
    env.NX_PUBLIC_SSO_FRONTEND_URL || "https://auth.songtradr.com",
  assetsUrl:
    env.NX_PUBLIC_ASSETS_URL || "https://assets.studio.massivemusic.com",
  heapId: "874137444",
});

/** Build-time Frontend Config
 *
 * Dispatched on `BUILD_CONFIGURATION` (injected by webpack per Nx configuration). Each build
 * configuration (e.g. `production`) spreads `defaults` and overrides what differs.
 * `env.X || fallback` lets CI-injected vars (e.g. PR preview backends) override at build time.
 *
 * See [env.ts](../env/env.ts) for `process.env` validation and when to use env vars instead.
 */
export const config = (
  {
    development,
    preview,
    staging,
    production,
  } satisfies Record<typeof BUILD_CONFIGURATION, Config>
)[BUILD_CONFIGURATION];
